import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {
  ApiResponse,
  APIRouteMap,
  ResetPasswordRecoveryPasswordCompleteApiNamespace,
  ResetPasswordRecoveryPasswordInitApiNamespace,
  ResetPasswordSetUserPasswordApiNamespace,
} from '@core/models/api';
import { map } from 'rxjs';

@Injectable()
export class ResetPasswordHttpService {
  private http = inject(HttpClient);


  setUserPassword(input: ResetPasswordSetUserPasswordApiNamespace.IN) {
    return this.http
      .post<ApiResponse<ResetPasswordSetUserPasswordApiNamespace.OUT>>(
        APIRouteMap.USER_SETUSERPASSWORD,
        input
      )
      .pipe(
        map((response) => {
          // const output = new ResetPasswordSetUserPasswordNamespace.OUT();
          // if (response.data) output.init(response.data);
          // return output;
          return response;
        })
      );
  }

  recoveryPasswordInit(
    input: ResetPasswordRecoveryPasswordInitApiNamespace.IN
  ) {
    return this.http
      .post<ApiResponse<ResetPasswordRecoveryPasswordInitApiNamespace.OUT>>(
        APIRouteMap.USER_RECOVERYPASSWORDINIT,
        input
      )
      .pipe(
        map((response) => {
          // const output = new ResetPasswordSetUserPasswordNamespace.OUT();
          // if (response.data) output.init(response.data);
          // return output;
          return response;
        })
      );
  }

  recoveryPasswordComplete(
    input: ResetPasswordRecoveryPasswordCompleteApiNamespace.IN
  ) {
    return this.http
      .post<ApiResponse<ResetPasswordRecoveryPasswordCompleteApiNamespace.OUT>>(
        APIRouteMap.USER_RECOVERYPASSWORDCOMPLETE,
        input
      )
      .pipe(
        map((response) => {
          // const output = new ResetPasswordSetUserPasswordNamespace.OUT();
          // if (response.data) output.init(response.data);
          // return output;
          return response;
        })
      );
  }
}
